// extracted by mini-css-extract-plugin
export default {"aboutBg":"Solution_aboutBg__HsEPR"};